import { Node, mergeAttributes } from '@tiptap/core'

export interface HorizontalRuleOptions {
  HTMLAttributes: Record<string, unknown>
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    horizontalRuleEmail: {
      setHorizontalRule: () => ReturnType
    }
  }
}

export const HorizontalRuleEmail = Node.create<HorizontalRuleOptions>({
  name: 'horizontalRule',

  group: 'block',

  atom: true,

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  parseHTML() {
    return [{ tag: 'hr' }]
  },

  renderHTML({ HTMLAttributes }) {
    // Email için inline style - ince çizgi
    return [
      'hr',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        style: 'border: none; border-top: 1px solid #e0e0e0; margin: 16px 0; height: 0;',
      }),
    ]
  },

  addCommands() {
    return {
      setHorizontalRule:
        () =>
        ({ chain }) => {
          return chain()
            .insertContent({ type: this.name })
            .run()
        },
    }
  },
})

export default HorizontalRuleEmail
